<template>
  <div>
    <div class="dashboard-status-organizations">
      <span class="dashboard-status-organizations-title">{{ $t('label_dashboard_status_totalEawPlatform') }}</span>
      <span class="dashboard-status-organizations-total">{{ chartData.total  || 0}}</span>
      <span class="dashboard-status-organizations-percentage">(100%)</span>
    </div>
    <div class="dashboard-status-container">
      <div :key="seal.seal" class="dashboard-status-item-container" v-for="seal of seals">
        <div class="dashboard-status-item">
          <div class="dashboard-status-label">{{ $t(seal.seal) }}</div>
          <div class="dashboard-status-values-container">
            <div class="dashboard-status-values-percentage">{{ seal.percentage }}%</div>
            <div class="dashboard-status-values-count">{{ seal.count }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "DashboardStatus",
  props: {
    chartData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      seals: []
    };
  },
  watch: {
    chartData: {
      handler: function () {
        this.formatChartData();
      },
      deep: true
    }
  },
  mounted() {
    this.formatChartData()
  },
  methods: {
    formatChartData: function () {
      if (!this.chartData?.data?.length) {
        this.seals = [
          {
            seal: 'label_dashboard_status_gold',
            count: 0,
            percentage:0
          },
          {
            seal: 'label_dashboard_status_silver',            count: 0,
            percentage:0
          },
          {
            seal: 'label_dashboard_status_bronze',            count: 0,
            percentage:0
          },
          {
            seal: 'label_dashboard_status_recognition',            count:  this.chartData.total,
            percentage:100
          },
        ]
      }
      var countGold = this.chartData.data.find(cd => cd._id === 'label_evaluation_gold')?.count ?? 0
      var countSilver = this.chartData.data.find(cd => cd._id === 'label_evaluation_silver')?.count ?? 0
      var countBronze = this.chartData.data.find(cd => cd._id === 'label_evaluation_bronze')?.count ?? 0
      var countNa = this.chartData.total - (countGold + countSilver + countBronze)
      this.seals = [
        {
          seal: 'label_dashboard_status_gold',
          count: countGold,
          percentage: this.chartData.total ?  Math.round(100 * (countGold / this.chartData.total)) : 0
        },
        {
          seal: 'label_dashboard_status_silver',
          count: countSilver,
          percentage: this.chartData.total ? Math.round(100 * (countSilver / this.chartData.total)) :0
        },
        {
          seal: 'label_dashboard_status_bronze',
          count: countBronze,
          percentage: this.chartData.total ? Math.round(100 * (countBronze / this.chartData.total)) : 0
        },
        {
          seal: 'label_dashboard_status_recognition',
          count: countNa,
          percentage: this.chartData.total ? Math.round(100 * (countNa / this.chartData.total)) : 0
        },
      ]
    }
  },
};
</script>
<style lang="scss" scoped>
.dashboard-status-organizations {
  text-align: center;
  padding-bottom: 5px;
  font-family: "Poppins-Regular", sans-serif;

  .dashboard-status-organizations-title {
    font-size: 0.875rem;
    font-family: "Poppins-Regular", sans-serif;
  }

  .dashboard-status-organizations-total {
    padding: 0 5px 0 10px;
    font-family: "Poppins-Bold", sans-serif;
    color: #1E4381;
    font-size: 1rem;
  }

  .dashboard-status-organizations-percentage {
    text-align: center;
    color: #1E4381;
    font-size: 0.875rem;
    font-family: "Poppins-Regular", sans-serif;
  }
}

.dashboard-status-container {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 0 10px;

}

.dashboard-status-item-container {
  flex-basis: calc(50% - 3px);
  max-width: calc(50% - 3px);
  flex-grow: 0;
  flex-shrink: 0;
  padding: 5px 5px 5px 10px;
}


.dashboard-status-item {
  background-color: #FFFFFF;
  padding: 10px 15px;
  line-height: 1;
  box-shadow: 0px 2px 6px #53381829;
}

.dashboard-status-label {
  font-size: 0.875rem;
  font-family: "Poppins-Bold", sans-serif;
}

.dashboard-status-values {
  &-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  &-percentage {
    color: #1E4381;
    font-size: 0.875rem;
    font-family: "Poppins-Regular", sans-serif;
  }

  &-count {
    color: #1E4381;
    font-size: 1.875rem;
    font-weight: 600;
    font-family: "Poppins-Bold", sans-serif;
  }
}
</style>
